export default [
	{
		start: 0.05,
		end: 4,
		text: 'Le rang 2 est proche ! Peu de Renégats ont su redresser la barre...'
	}
]
